import { validateInputOnlyDigits } from "../components/clientSideValidationUtil";
const regex = require("../utilities/regex");

const $cache = {
    document: $(document),
    body : $("body")
};

/**
 * Display section to edit Company Code
 */
const editCompanyCode = () => {
    $cache.document.on("click", ".js-edit-company-code", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);

        const sectionCompanyCode = document.querySelector(".billing-step--section-companycode");
        const sectionCompanyCodeResume = sectionCompanyCode.querySelector(".js-billing-companycode--title-wrapper");
        const sectionCompanyCodeExpanded = sectionCompanyCode.querySelector(".js-billing-companycode--expanded-wrapper");

        sectionCompanyCodeResume.classList.add("d-none");
        sectionCompanyCodeExpanded.classList.remove("d-none");
        $this.tooltip("hide");
    });
};

/**
 * Update Company Code - for B2B customers
 */
const saveCompanyCode = () => {
    const companyCodeConfirm = document.querySelector(".js-billing-companycode-confirm");
    const companyCodeInput = document.getElementById("billing-companycode");

    if (!companyCodeConfirm) {
        return;
    }

    const taxNumberInput = document.getElementById("billing-companycode");

    companyCodeConfirm.addEventListener("click", e => {
        const btnConfirm = e.currentTarget;
        const url = btnConfirm.getAttribute("data-action");
        const companyCodeInputError = document.getElementById("js-billing-companycode-error");
        const companyCodeValue = companyCodeInput.value || "";
        const taxNumberValue = taxNumberInput.value;

        // check errors
        companyCodeInputError.innerHTML = "";
        companyCodeInput.classList.remove("is-invalid");

        if (companyCodeValue !== "" && !regex.values.companyCode.test(companyCodeValue)) {
            companyCodeInput.classList.add("is-invalid");
            companyCodeInputError.innerHTML = companyCodeInput.getAttribute("data-pattern-mismatch");
            return;
        }

        const dataObj = {
            companyCodeValue: companyCodeValue,
            taxNumberValue: taxNumberValue
        };

        const csrfInput = $(".billing-address-csrf");
        dataObj[csrfInput.attr("name")] = csrfInput.val();

        $.ajax({
            url: url,
            method: "POST",
            data: dataObj,
            success: data => {
                if (data && data.isValidCompanyCode) {
                    const sectionCompanyCode = document.querySelector(".billing-step--section-companycode");
                    const sectionCompanyCodeResume = sectionCompanyCode.querySelector(".js-billing-companycode--title-wrapper");
                    const sectionCompanyCodeResumeValue = sectionCompanyCode.querySelector(".js-companycode-value");
                    const sectionCompanyCodeExpanded = sectionCompanyCode.querySelector(".js-billing-companycode--expanded-wrapper");

                    sectionCompanyCodeResumeValue.innerHTML = data.companyCode;
                    if (data.companyCode !== "") {
                        sectionCompanyCodeResume.classList.remove("d-none");
                        sectionCompanyCodeExpanded.classList.add("d-none");
                    }
                }
            }
        });
    });

    companyCodeInput.addEventListener("keyup", e => {
        if (e.key === "Enter") {
            companyCodeConfirm.click();
        }
    });
};

/**
 * Update Tax Number and Company Name
 */
const saveBillingInfo = () => {
    const billingInfoConfirm = document.querySelector(".js-submit-billing-info-button");

    if (!billingInfoConfirm) return;

    const taxNumberInput = document.getElementById("billing-taxnumber");
    const companyNameInput = document.getElementById("companyNameInput");
    const saveBillingInfoCheckbox = document.getElementById("billing-checkbox");
    const isCompany = document.getElementById("isCompany")?.value === "true";
    const taxNumberInputError = document.getElementById("js-billing-taxnumber-error");
    const companyNameInputError = document.getElementById("js-billing-companyname-error");

    taxNumberInput.addEventListener("input", (e) => {
        e.target.value = e.target.value.replace(/\D/g, "").replace(/(\d{3})(?=\d)/g, "$1 ");
    });

    const validateFields = () => {
        let isValid = true;

        // Reset errors
        [taxNumberInput, companyNameInput].forEach(input => input?.classList.remove("is-invalid"));
        taxNumberInputError.innerHTML = "";
        
        if (isCompany) {
            //reset error
            companyNameInputError.innerHTML = "";

            if (!taxNumberInput.value.trim()) {
                taxNumberInput.classList.add("is-invalid");
                taxNumberInputError.innerHTML = taxNumberInput.getAttribute("data-missing-error");
                isValid = false;
            } else if (!regex.values.taxNumber.test(taxNumberInput.value)) {
                taxNumberInput.classList.add("is-invalid");
                taxNumberInputError.innerHTML = taxNumberInput.getAttribute("data-pattern-mismatch");
                isValid = false;
            }

            if (!companyNameInput.value.trim()) {
                companyNameInput.classList.add("is-invalid");
                companyNameInputError.innerHTML = companyNameInput.getAttribute("data-missing-error");
                isValid = false;
            } else if (!regex.values.companyName.test(companyNameInput.value)) {
                companyNameInput.classList.add("is-invalid");
                companyNameInputError.innerHTML = companyNameInput.getAttribute("data-pattern-mismatch");
                isValid = false;
            }
        }

        return isValid;
    };

    billingInfoConfirm.addEventListener("click", () => {
        if (!validateFields()) return;

        const url = billingInfoConfirm.getAttribute("data-action");
        const csrfInput = $(".billing-address-csrf");

        const dataObj = {
            taxNumberValue: taxNumberInput.value,
            companyNameValue: companyNameInput?.value || "",
            isSaveBillingInfo: saveBillingInfoCheckbox.checked,
            [csrfInput.attr("name")]: csrfInput.val()
        };

        $.ajax({
            url: url,
            method: "POST",
            data: dataObj,
            success: (data) => {
                const $billingAddressModal = $("#billing-addresses-area-modal");

                if (data?.isValidTaxNumber) {
                    document.querySelector(".js-taxnumber-value").textContent = data.taxNumber?.replace(/\B(?=(\d{3})+(?!\d))/g, " ") || "";
                } else {
                    taxNumberInput.classList.add("is-invalid");
                    taxNumberInputError.innerHTML = taxNumberInput.getAttribute("data-pattern-mismatch");
                }

                if (isCompany) {
                    if (data?.isValidCompanyName) {
                        document.querySelector(".js-companyname-value").value = data.companyName || "";
                    } else {
                        companyNameInput.classList.add("is-invalid");
                        companyNameInputError.innerHTML = companyNameInput.getAttribute("data-pattern-mismatch");
                    }
                }

                if (data?.isValidTaxNumber && data?.isValidCompanyName) {
                    $billingAddressModal.modal("hide");
                }
            }
        });
    });

    taxNumberInput.addEventListener("keyup", (e) => {
        if (e.key === "Enter") billingInfoConfirm.click();
    });
};

/**
 * Handle Billing Address selection
 */
const handleBillingAddressSelection = () => {
    document.querySelectorAll(".js-billing-address-selection .js-submit-billing-info-button").forEach(radioInput => {
        radioInput.addEventListener("click", () => {
            const addressWrapper = document.querySelector(".js-billing-address-selection");
            const url = addressWrapper.getAttribute("data-action");
            const $selectedAddress = $("input[name=billingAddress]:checked").get(0);

            const csrfInput = $(".billing-address-csrf");
            const dataObj = {
                addressId: $selectedAddress.value
            };
            dataObj[csrfInput.attr("name")] = csrfInput.val();

            $.ajax({
                url: url,
                method: "POST",
                data: dataObj,
                success: data => {
                    if (data && !data.error) {
                        const sectionAddresses = document.querySelector(".billing-step--section-address");

                        $(".js-billing-address-selected").replaceWith(data.selectedBillingAddressesTemplate);
                        sectionAddresses.querySelector(".js-billing-address--title-wrapper").classList.remove("d-none");
                        sectionAddresses.querySelector(".js-billing-addresses-list").classList.add("d-none");
                        sectionAddresses.querySelector(".js-billing-step--section-wrapper-value").classList.remove("d-none");
                    }
                }
            });
        });
    });
};

/**
 * Render Billing Addresses list in modal on mobile
 */
const displayBillingAddressesModal = () => {
    const btnModalOpen = document.querySelector(".js-billing-addresses--modal-open");
    const url = btnModalOpen.getAttribute("data-action");

    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: data => {
                if (data && !data.error) {
                    const html = data.availableBillingAddressesTemplate;

                    if (html) {
                        document.querySelector(".js-billing-addresses-modal-body").innerHTML = html;

                        // remove addresses from page section
                        if (document.querySelector(".billing-step--section-address .js-billing-address-selection")) {
                            const addressSelection = document.querySelector(".billing-step--section-address .js-billing-address-selection");
                            addressSelection.parentNode.removeChild(addressSelection);
                        }

                        // reinit events
                        handleBillingAddressSelection();
                        saveBillingInfo();
                    }
                }
            }
        });
    }
};

/**
 * Init Billing events
 */
const initBillingEvents = () => {
    editCompanyCode();
    saveCompanyCode();
    saveBillingInfo();
    validateInputOnlyDigits("#billing-taxnumber");
};

export { initBillingEvents, displayBillingAddressesModal };
